// src/components/layout/Footer.js

import { Shield, FileText, Mail } from "lucide-react";
import "./Footer.css";

const Footer = ({ children, darkMode, setDarkMode }) => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { href: "/privacy", label: "Privacy Policy", icon: Shield },
    { href: "/terms", label: "Termes de Service", icon: FileText },
    { href: "/contact", label: "Contactez-Nous", icon: Mail },
  ];

  return (
    <footer className={`footer ${darkMode ? "dark" : ""}`}>
      <div className="footer-content">
        <p className="footer-copyright">
          &copy; {currentYear} SanlamAllianz BURKINA FASO. Tous droits réservés.
        </p>
        <div className="footer-links">
          {footerLinks.map((link) => (
            <a key={link.href} href={link.href} className="footer-link">
              <link.icon size={16} strokeWidth={2} />
              <span>{link.label}</span>
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
